<template>
  <div class="report_item_content">
    <report-topbar @schedule="scheduleModal = true" />
    <div
      v-if="report && report.is_template && report.ga_version && report.ga_version !== user.ga_version"
      class="pb_small ga_version_warning"
    >
      This template was created using Google Analytics {{ report.ga_version === 'ga3' ? 'V3' : 'V4' }} widgets, whereas
      your active website is connected to Google Analytics {{ user.ga_version === 'ga3' ? 'V3' : 'V4' }}.<br>
      Any Google Analytics widgets you add/update will be will {{ user.ga_version === 'ga3' ? 'V3' : 'V4' }} widgets, and
      may cause issues when creating a report from this template.<br>
      <a
        href="javascript:;"
        @click="updateGAReference(user.ga_version)"
      >Click here to update this template to Google
        Analytics {{ user.ga_version === 'ga3' ? 'V3' : 'V4' }}</a>
    </div>
    <div
      v-if="report"
      id="report_main"
    >
      <report-page
        v-for="(page, index) in pages"
        :key="page.position"
        :index="index"
        :page="page"
      >
        <gridstack-container
          :ref="'p'+page.id+'-gridstack'"
          :page="page"
        />
      </report-page>
    </div>
  </div>

  <edit-report-modal
    v-if="reportModal.type"
  />

  <order-pages-modal
    v-if="widgetModal.modal === 'reorder'"
  />

  <add-widget-modal
    v-if="widgetModal.modal === 'new'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget, true);}"
  />

  <google-analytics-modal
    v-if="widgetModal.modal === 'ga'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget, true);}"
  />

  <AiSummaryModal
    v-if="widgetModal.modal === 'ai-summary'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget, true);}"
  />

  <google-search-console-modal
    v-if="widgetModal.modal === 'gsc'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget, true);}"
  />

  <heading-modal
    v-if="widgetModal.modal === 'heading'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget, true);}"
  />

  <textarea-modal
    v-if="widgetModal.modal === 'textarea'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget, true);}"
  />

  <image-modal
    v-if="widgetModal.modal === 'image'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget, true);}"
  />

  <keywords-modal
    v-if="widgetModal.modal === 'keywords'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget, true);}"
  />

  <backlinks-modal
    v-if="widgetModal.modal === 'backlinks'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget, true);}"
  />

  <actions-modal
    v-if="widgetModal.modal === 'actions'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget, true);}"
  />

  <reviews-modal
    v-if="widgetModal.modal === 'reviews'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget, true);}"
  />

  <insights-modal
    v-if="widgetModal.modal === 'insights'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget, true);}"
  />

  <performance-modal
    v-if="widgetModal.modal === 'performance'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget, true);}"
  />

  <local-posts-modal
    v-if="widgetModal.modal === 'local-posts'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget);}"
  />

  <local-rankings-modal
    v-if="widgetModal.modal === 'local-rankings'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget);}"
  />

  <competition-modal
    v-if="widgetModal.modal === 'competition'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget);}"
  />

  <table-modal
    v-if="widgetModal.modal === 'table'"
    @refresh-widget="payload => {$refs['p'+payload.pageId+'-gridstack'][0].generateWidget(payload.widget);}"
  />

  <schedule-modal
    v-if="scheduleModal"
    @close="scheduleModal = false"
  />
</template>

<script>
import _ from 'lodash';
import Swal from 'sweetalert2';

import {mapActions, mapState} from 'vuex';
import ReportTopbar from './ReportTopbar.vue';
import ReportPage from './ReportPage.vue';
import GridstackContainer from './GridstackContainer.vue';

import AddWidgetModal from '../modals/AddWidget.vue';
import EditReportModal from '../../index/modals/EditReport.vue';
import OrderPagesModal from '../modals/OrderPages.vue';

import HeadingModal from '../modals/HeadingModal.vue';
import TextareaModal from '../modals/TextareaModal.vue';
import ImageModal from '../modals/ImageModal.vue';
import TableModal from '../modals/TableModal.vue';
import KeywordsModal from '../modals/KeywordsModal.vue';
import BacklinksModal from '../modals/BacklinksModal.vue';
import ActionsModal from '../modals/ActionsModal.vue';
import ReviewsModal from '../modals/ReviewsModal.vue';
import InsightsModal from '../modals/InsightsModal.vue';
import PerformanceModal from "../modals/PerformanceModal.vue";
import LocalPostsModal from '../modals/LocalPosts.vue';
import LocalRankingsModal from '../modals/LocalRankings.vue';
import CompetitionModal from '../modals/CompetitionModal.vue';
import GoogleAnalyticsModal from '../modals/GoogleAnalytics.vue';

import GoogleSearchConsoleModal from '../modals/GoogleSearchConsole.vue';
import ScheduleModal from '../modals/ScheduleModal.vue';
import AiSummaryModal from "../modals/AiSummaryModal.vue";

export default {
  components: {
    AiSummaryModal,
    ReportTopbar,
    ReportPage,
    GridstackContainer,
    AddWidgetModal,

    EditReportModal,
    OrderPagesModal,
    HeadingModal,

    TextareaModal,
    ImageModal,
    TableModal,
    KeywordsModal,
    BacklinksModal,
    ActionsModal,
    ReviewsModal,
    InsightsModal,
    PerformanceModal,
    LocalPostsModal,
    LocalRankingsModal,
    CompetitionModal,

    GoogleAnalyticsModal,
    GoogleSearchConsoleModal,

    ScheduleModal
  },
  data() {
    return {
      scheduleModal: false,
      pageWidthPx: 0,
      grids: [],
    }
  },
  computed: {
    ...mapState('pages', ['pages']),
    ...mapState('report', ['report']),
    ...mapState('user', ['user']),
    ...mapState(['widgetModal']),
    ...mapState(['reportModal'])
  },
  mounted() {
    this.loadLookups();
  },
  updated() {
    // Adding watchers after updated to prevent trigger on initial report load
    this.$watch('report.orientation', function () {
      this.refreshPages({type: this.report.is_template ? 'templates' : 'reports', id: this.report.id})
    });
    this.$watch('report.from_date', function () {
      this.debounceRefreshGrid('from_date');
    });
    this.$watch('report.to_date', function () {
      this.debounceRefreshGrid('to_date');
    });
    this.$watch('report.date_range', function () {
      this.debounceRefreshGrid('date_range');
    });
    this.$watch('report.comp_from_date', function () {
      this.debounceRefreshGrid('comp_range');
    });
    this.$watch('report.comp_to_date', function () {
      this.debounceRefreshGrid('comp_range');
    });
    this.$watch('report.comp_range', function () {
      this.debounceRefreshGrid('comp_range');
    });
    this.$watch('report.date_format', function () {
      this.debounceRefreshGrid('date_format');
    });
    this.$watch('dataType', function () {
      this.debounceRefreshGrid('dataType');
    });
  },
  methods: {
    ...mapActions({
      openModal: 'widgetModal/openModal',
      closeModal: 'widgetModal/closeModal',
      fetchReport: 'report/fetchReport',
      refreshPages: 'pages/getReportPages',
      loadLookups: 'lookups/getAllLookups',
      updateGAVersion: 'report/updateGAVersion'
    }),
    debounceRefreshGrid: _.debounce(function (val) {
      this.refreshGrid(val);
    }, 1000),
    /**
     * Refreshes the whole Gridstack grid and all widgets within.
     *
     * @return  void
     */
    refreshGrid(val) {
      _.each(this.pages, page => {
        this.$refs['p' + page.id + '-gridstack'][0].refreshGrid(val);
      });
    },
    updateGAReference(version) {
      Swal.fire({
        title: `Are you sure?`,
        icon: 'warning',
        html: `This will only update this templates reference to Google Analytics ${version === 'ga3' ? 'V3' : 'V4'}
                       <br>Any Google Analytics widgets on this template will need to be updated manually.`,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'I understand, Update',
        confirmButtonColor: '#37B2A8',
        showLoaderOnConfirm: true,
        backdrop: true,
        preConfirm: async () => {
          await this.updateGAVersion({id: this.report.id, version: version})
            .then(response => response);
        },
        allowOutsideClick: () => !Swal.isLoading()
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: `Updated successfully`,
            icon: 'success'
          });
        }
      });
    },
  }
}
</script>

<style scoped>
.loading_backdrop {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  height: 100vh;
  width: 100vw;
  background-color: gray;
  opacity: 0.4;
}

.report_item_content {
  width: 75vw;
}

.ga_version_warning {
  text-align: center;
  background: #d47777;
  color: #FFFFFF;
  border-radius: 25px;
  padding: 10px;
}

.ga_version_warning a {
  color: #FFFFFF;
  text-decoration: underline;
}
</style>
